import React, { Component } from 'react';
import { View, StyleSheet, ScrollView } from 'react-native';

import { __WEB__, COLOR, FONT, FONT_SIZE, THEME } from '../../../../constants/styles';

import OPComponent from '../../op_component';
import ImageView from '../../image_view';
import CachedImage from '../../attachments/cached_image';
import { ImageRemove } from './image_remove';

import { getFullscreenImageUrl } from '../../attachments/web_fullscreen';

import Toolbar from './toolbar';

const IMAGE_WIDTH = 90;
const IMAGE_HEIGHT = 60;

export default class AttachmentsInput extends OPComponent {
  constructor(props) {
    super(props);
  }

  showFullScreen = async (attachment) => {
    if (__WEB__) {
      const url = await getFullscreenImageUrl(attachment);
      if (url) window.open(url, '_blank');
      return;
    }
  };

  renderExistingAttachment = (attachment, i) => {
    const removedAttachments = this.props.removedAttachments;
    const isRemoved = removedAttachments.indexOf(attachment) >= 0;
    // return an empty view with the same key so that the image views
    // will not be re-rendered and recycled with a different attachment
    // object, causing the spinners to spin
    if (isRemoved) return <View key={i} />;

    const isThumb = !(this.props.isThumb === false);

    return (
      <ImageRemove
        containerStyle={styles.imageContainer}
        key={i}
        attachment={attachment}
        onRemove={this.props.onRemove}
        hideRemoveButton={true}
      >
        <CachedImage
          width={IMAGE_WIDTH}
          height={IMAGE_HEIGHT}
          attachment={attachment}
          isThumb={isThumb}
          onPress={__WEB__ ? this.showFullScreen : null}
        />
      </ImageRemove>
    );
  };

  renderNewAttachment = (attachment, i) => {
    return (
      <ImageRemove
        containerStyle={styles.imageContainer}
        key={i}
        attachment={attachment}
        onRemove={this.props.onRemove}
        hideRemoveButton={this.props.disabled || false}
      >
        <ImageView width={IMAGE_WIDTH} height={IMAGE_HEIGHT} imageUri={attachment.image.uri} />
      </ImageRemove>
    );
  };

  render() {
    const { attachments, newAttachments, onAdd, disabled } = this.props;

    return (
      <View style={THEME.container}>
        {!disabled && <Toolbar onAddFromCamera={onAdd} onAddFromImagePicker={onAdd} />}

        {!!(attachments?.length || newAttachments?.length) && (
          <View style={styles.images}>
            <ScrollView horizontal={true}>
              {attachments?.map?.(this.renderExistingAttachment)}
              {newAttachments?.map?.(this.renderNewAttachment)}
            </ScrollView>
          </View>
        )}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  images: {
    height: 90,
    // backgroundColor: 'pink'
  },
  imageContainer: {
    marginRight: 5,
  },
});
